import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { Input, Button, List } from "antd";
import {
  LockOutlined,
  UserOutlined,
  MailOutlined,
  NumberOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, verifyForceOtp } from "../Redux/Slice/Login/Login";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useRegisterFcm from "../call/fcmtoken";
import { motion } from "framer-motion";
import PersonIcon from "@mui/icons-material/Person";
import { Modal } from "antd";
// import FingerprintJS from "@fingerprintjs/fingerprintjs";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [step, setStep] = useState("login");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [branches, setBranches] = useState(null); // ✅ null initially
  const [deviceId, setDeviceId] = useState("UNKNOWN_DEVICE");
  const [forceLoginVisible, setForceLoginVisible] = useState(false);
  const [forceLoginData, setForceLoginData] = useState(null);
  const [otpCode, setOtpCode] = useState("");
  const [isForceLoginFlow, setIsForceLoginFlow] = useState(false);

  console.log("forceLoginData", forceLoginData);

  const { loading, data, error, verify } = useSelector((state) => state.login);

  useEffect(() => {
    const uniqueId = crypto.randomUUID(); // random unique id
    setDeviceId(uniqueId);
  }, []);

  // Auto-login check
  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");

    if (token && storedUser) {
      const user = JSON.parse(storedUser);
      console.log("user", user)
      if (user?.isLoggedIn) {
        if (user?.roleName === "ADMIN") navigate("/dashboard");
        else if (user.roleName.toLowerCase() === "doctor")
          navigate("/doc-dashboard");
        else navigate("/patient-dashboard");
      }
    }
  }, [navigate]);

  // Register FCM token
  useRegisterFcm(data?.data?.userId);

  useEffect(() => {
    if (!isForceLoginFlow && data?.status && !forceLoginVisible) {
      toast.success(data.message || "Login successful!");
      const user = data.data?.user;

      const storedUser = {
        userId: user?.id || user?.userId,
        userName: user?.userName,
        fullName: user?.fullName,
        email: user?.email,
        phoneNo: user?.phoneNo,
        roleId: user?.roleMaster?.roleId,
        roleName: user?.roleMaster?.roleName,
        roleAccess: data.data?.roleAccess || [],
        isLoggedIn: true,
        doctorId: user?.doctor?.doctorId,
        patientId: data?.data?.patientId,
      };

      localStorage.setItem("token", data.data.token);
      localStorage.setItem("user", JSON.stringify(storedUser));

      if (
        ["doctor", "admin", "receptionist"].includes(
          storedUser?.roleName?.toLowerCase()
        )
      ) {
        setBranches(data.data.branches || []);
      } else {
        navigate("/patient-dashboard");
      }
    }
  }, [data, error, navigate, isForceLoginFlow, forceLoginVisible]);

  useEffect(() => {
    if (verify?.data?.status) {
      toast.success(verify?.data.message);
      const user = verify?.data?.data?.user;

      const storedUser = {
        userId: user?.id || user?.userId,
        userName: user.userName,
        fullName: user.fullName,
        email: user.email,
        phoneNo: user.phoneNo,
        roleId: user.roleMaster?.roleId,
        roleName: user.roleMaster?.roleName,
        roleAccess: data.data?.roleAccess || [],
        isLoggedIn: true,
        doctorId: user.doctor?.doctorId,
        patientId: data?.data?.patientId,
      };

      localStorage.setItem("token", verify?.data.data.token);
      localStorage.setItem("user", JSON.stringify(storedUser));

      if (
        ["doctor", "admin", "receptionist"].includes(
          storedUser?.roleName?.toLowerCase()
        )
      ) {
        setBranches(verify?.data.data.branches || []);
      } else {
        navigate("/patient-dashboard");
      }
    }
  }, [data, error, navigate, verify?.data]);

  useEffect(() => {
    if (verify?.error) {
      toast.error(verify?.error?.message || "Login failed!");
    }
  }, [verify?.error]);

  const handleLogin = () => {
    if (userName && password) {
      dispatch(loginUser({ userName, password, deviceId })).then((res) => {
        if (res?.payload?.status) {
          const user = res?.payload?.data?.user;
          const role = user?.roleMaster?.roleName;

          if (role === "Doctor") {
            // ✅ show branch selection
            setBranches(res?.payload?.data?.branches || []);
          }
        } else if (
          res?.payload.status === false &&
          res?.payload.data?.isLoggedIn
        ) {
          // Show confirmation modal when already logged in elsewhere
          setForceLoginVisible(true);
          setForceLoginData(res);
        }
      });
    } else {
      toast.warning("Please enter Username and Password");
    }
  };

  const handleResetPassword = () => {
    if (newPass === confirmPass) {
      toast.success("Password reset successfully!");
      setStep("login");
    } else {
      toast.error("Passwords do not match!");
    }
  };

  localStorage.setItem("branches", JSON.stringify(branches || []));

  const handleBranchSelect = (branch) => {
    localStorage.setItem("selectedBranchId", branch.branchId);

    const user = JSON.parse(localStorage.getItem("user"));
    const role = user?.roleName?.toLowerCase();

    if (role === "doctor") navigate("/doc-dashboard");
    else if (role === "admin") navigate("/dashboard");
    else if (role === "receptionist") navigate("/recp-dashboard");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        bgcolor: "#f9fafb",
        overflow: "hidden",
      }}
    >
      {/* ===== LEFT PANEL ===== */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          color: "white",
          px: 6,
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
          background:
            "linear-gradient(270deg, #1e3c72, #2a5298, #16a085, #2c3e50)",
          backgroundSize: "800% 800%",
          animation: "gradientShift 15s ease infinite",
          "@keyframes gradientShift": {
            "0%": { backgroundPosition: "0% 50%" },
            "50%": { backgroundPosition: "100% 50%" },
            "100%": { backgroundPosition: "0% 50%" },
          },
        }}
      >
        {/* Abstract Blur Circles */}
        <Box
          sx={{
            position: "absolute",
            top: "-20%",
            right: "-30%",
            width: "400px",
            height: "400px",
            background: "rgba(255,255,255,0.1)",
            borderRadius: "50%",
            filter: "blur(80px)",
            animation: "float1 8s ease-in-out infinite",
            "@keyframes float1": {
              "0%, 100%": { transform: "translateY(0)" },
              "50%": { transform: "translateY(20px)" },
            },
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: "-20%",
            left: "-30%",
            width: "350px",
            height: "350px",
            background: "rgba(255,255,255,0.08)",
            borderRadius: "50%",
            filter: "blur(100px)",
            animation: "float2 10s ease-in-out infinite",
            "@keyframes float2": {
              "0%, 100%": { transform: "translateX(0)" },
              "50%": { transform: "translateX(25px)" },
            },
          }}
        />

        {/* LEFT CONTENT */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            px: 8,
            maxWidth: "600px",
            textAlign: "left",
            gap: 2,
            zIndex: 2,
          }}
        >
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <Typography
              variant="h3"
              fontWeight="bold"
              gutterBottom
              sx={{ lineHeight: 1.2 }}
            >
              Your Health, Anytime. Anywhere.
            </Typography>

            <Typography
              variant="h6"
              sx={{ mb: 3, color: "rgba(255,255,255,0.9)" }}
            >
              Connect instantly with trusted doctors, book appointments online,
              and access your reports securely – all from the comfort of home.
            </Typography>

            <Box component="ul" sx={{ pl: 3, lineHeight: 2, fontSize: "16px" }}>
              <li>💬 24/7 Video Consultations</li>
              <li>📅 Easy Appointment Scheduling</li>
              <li>🔒 Secure & Private Records</li>
            </Box>
          </motion.div>
        </Box>
      </Box>

      {/* ===== RIGHT PANEL ===== */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 4,
        }}
      >
        {branches && branches.length > 0 ? (
          // ✅ Branch selection list
          <Box
            sx={{
              width: 380,
              background: "white",
              borderRadius: 4,
              boxShadow: 6,
              p: 4,
            }}
          >
            <Typography
              variant="h6"
              align="center"
              gutterBottom
              sx={{ fontWeight: "bold", mb: 3, color: "#1d629e" }}
            >
              Select a Branch
            </Typography>
            <List
              dataSource={branches}
              renderItem={(branch) => (
                <List.Item
                  onClick={() => handleBranchSelect(branch)}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    border: "1px solid #ddd",
                    marginBottom: "8px",
                    borderRadius: "6px",
                  }}
                >
                  <strong>{branch.branchName}</strong> - {branch.location}
                </List.Item>
              )}
            />
          </Box>
        ) : (
          // ✅ Login Form
          <Box
            sx={{
              width: 380,
              background: "white",
              borderRadius: 4,
              boxShadow: 6,
              p: 4,
            }}
          >
            <Typography
              variant="h5"
              align="center"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#1d629e", mb: 3 }}
            >
              <Box textAlign="center" mb={1}>
                <PersonIcon fontSize="large" color="primary" />
              </Box>
              Login to your account
            </Typography>

            {/* LOGIN FORM */}
            {step === "login" && (
              <Box display="flex" flexDirection="column" gap={2}>
                <Input
                  size="large"
                  placeholder="UserName"
                  prefix={<UserOutlined />}
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />
                <Input.Password
                  size="large"
                  placeholder="Password"
                  prefix={<LockOutlined />}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                <Button
                  type="primary"
                  block
                  size="large"
                  loading={loading && !forceLoginVisible}
                  onClick={handleLogin}
                >
                  {"Login"}
                </Button>

                <Button type="link" block onClick={() => setStep("forgot")}>
                  Forgot Password?
                </Button>

                <Button type="link" block onClick={() => navigate("/register")}>
                  Register as New Patient
                </Button>
              </Box>
            )}

            {/* FORGOT PASSWORD */}
            {step === "forgot" && (
              <Box display="flex" flexDirection="column" gap={2}>
                <Input
                  size="large"
                  placeholder="Registered Email"
                  prefix={<MailOutlined />}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <Button
                  type="primary"
                  block
                  size="large"
                  onClick={() => setStep("otp")}
                >
                  Send OTP
                </Button>
                <Button type="link" block onClick={() => setStep("login")}>
                  Back to Login
                </Button>
              </Box>
            )}

            {/* OTP STEP */}
            {step === "otp" && (
              <Box display="flex" flexDirection="column" gap={2}>
                <Input
                  size="large"
                  placeholder="Enter OTP"
                  prefix={<NumberOutlined />}
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
                <Button
                  type="primary"
                  block
                  size="large"
                  onClick={() => setStep("reset")}
                >
                  Verify OTP
                </Button>
                <Button type="link" block onClick={() => setStep("forgot")}>
                  Back
                </Button>
              </Box>
            )}

            {/* RESET PASSWORD */}
            {step === "reset" && (
              <Box display="flex" flexDirection="column" gap={2}>
                <Input.Password
                  size="large"
                  placeholder="New Password"
                  prefix={<LockOutlined />}
                  value={newPass}
                  onChange={(e) => setNewPass(e.target.value)}
                />
                <Input.Password
                  size="large"
                  placeholder="Confirm Password"
                  prefix={<LockOutlined />}
                  value={confirmPass}
                  onChange={(e) => setConfirmPass(e.target.value)}
                />
                <Button
                  type="primary"
                  block
                  size="large"
                  icon={<ReloadOutlined />}
                  onClick={handleResetPassword}
                >
                  Reset Password
                </Button>
              </Box>
            )}

            {step === "ForceLoginOtp" && (
              <Box display="flex" flexDirection="column" gap={2}>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Please enter the OTP sent to your registered email or phone to
                  confirm login.
                </Typography>
                <Input
                  size="large"
                  placeholder="Enter OTP"
                  value={otpCode}
                  onChange={(e) => setOtpCode(e.target.value)}
                />
                <Box display="flex" justifyContent="flex-end" gap={2}>
                  <Button
                    onClick={() => {
                      setForceLoginVisible(false);
                      setStep("Login");
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    loading={verify?.loading}
                    onClick={() => {
                      if (!otpCode) {
                        toast.warning("Please enter OTP");
                        return;
                      }

                      // Force login with OTP
                      dispatch(
                        verifyForceOtp({
                          userId: forceLoginData?.payload?.data?.userId,
                          otp: otpCode,
                        })
                      ).then((res) => {
                        if (res?.payload?.status) {
                          toast.success("Login successful!");
                          setForceLoginVisible(false);
                        } else {
                          toast.error(
                            res?.payload?.message || "OTP verification failed"
                          );
                        }
                      });
                    }}
                  >
                    Verify OTP
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        )}
      </Box>
      <Modal
        open={forceLoginVisible}
        title="Active Session Detected"
        onCancel={() => setForceLoginVisible(false)}
        footer={null}
        centered
      >
        <Typography variant="body1" sx={{ mb: 2 }}>
          Your account is active on another device.
          <br />
          Do you want to login here?
        </Typography>

        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button onClick={() => setForceLoginVisible(false)}>No</Button>
          <Button
            type="primary"
            onClick={() => {
              setForceLoginVisible(false);
              setIsForceLoginFlow(true); // ✅ mark force login mode active

              // call force login API to trigger OTP
              dispatch(
                loginUser({ userName, password, deviceId, forceLogin: true })
              ).then((res) => {
                if (
                  res?.payload?.status === false &&
                  res?.payload?.message?.includes("OTP")
                ) {
                  toast.info("OTP sent for verification.");
                }
                // ✅ show ForceLoginOtp input
                setStep("ForceLoginOtp");
              });
            }}
          >
            Yes, Continue
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default Login;
